import { MsInHour } from '@shared/constants/times/ms-in-hour'

export const OneDayInMs: number = 24 * MsInHour
